import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WebtoolsService {
    static config = {
        loaderUrl: 'https://webtools.europa.eu/load.js',
        cckUrl: 'https://commission.europa.eu/cookies-policy_{lang}',
        etransConfig: {
            service: 'etrans',
            renderAs: {
                icon: false,
                button: false,
                link: false,
            },
        },
    };

    constructor() {
        // noop
    }

    loadLoadJs(): Observable<void> {
        return new Observable((observer) => {
            const script = document.createElement('script');
            script.setAttribute('src', WebtoolsService.config.loaderUrl);
            script.setAttribute('defer', '');
            script.setAttribute('type', 'text/javascript');

            const resolve = () => {
                observer.next();
                observer.complete();
            };

            const handleError = () => {
                observer.error(new Error('Failed to load script'));
            };

            script.onload = () => {
                this.loadWebToolWidget(WebtoolsService.config.etransConfig);
                resolve();
            };

            script.onerror = handleError;

            document.body.appendChild(script);
        });
    }

    loadWebToolWidget(config: object) {
        const script = document.createElement('script');
        script.setAttribute('type', 'application/json');
        script.innerHTML = JSON.stringify(config);
        document.body.appendChild(script);
    }
}
